var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "AppStatus" }, [
    _c("div", { staticClass: "circular shelf", class: [_vm.status] }),
    _c(
      "div",
      { staticClass: "title" },
      [_vm._v(" " + _vm._s(_vm.title) + " "), _vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }